import { parseAlgoliaHitHighlight, parseAlgoliaHitReverseHighlight, parseAlgoliaHitReverseSnippet, parseAlgoliaHitSnippet } from '@algolia/autocomplete-preset-algolia';
import { createElement as preactCreateElement } from 'preact';

/**
 * Highlights and escapes the matching parts of an Algolia hit.
 */
export function highlightHit(_ref) {
  var hit = _ref.hit,
      attribute = _ref.attribute,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'mark' : _ref$tagName,
      _ref$createElement = _ref.createElement,
      createElement = _ref$createElement === void 0 ? preactCreateElement : _ref$createElement;
  return parseAlgoliaHitHighlight({
    hit: hit,
    attribute: attribute
  }).map(function (x, index) {
    return x.isHighlighted ? createElement(tagName, {
      key: index
    }, x.value) : x.value;
  });
}
/**
 * Highlights and escapes the non-matching parts of an Algolia hit.
 *
 * This is a common pattern for Query Suggestions.
 */

export function reverseHighlightHit(_ref2) {
  var hit = _ref2.hit,
      attribute = _ref2.attribute,
      _ref2$tagName = _ref2.tagName,
      tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName,
      _ref2$createElement = _ref2.createElement,
      createElement = _ref2$createElement === void 0 ? preactCreateElement : _ref2$createElement;
  return parseAlgoliaHitReverseHighlight({
    hit: hit,
    attribute: attribute
  }).map(function (x, index) {
    return x.isHighlighted ? createElement(tagName, {
      key: index
    }, x.value) : x.value;
  });
}
/**
 * Highlights and escapes the matching parts of an Algolia hit snippet.
 */

export function snippetHit(_ref3) {
  var hit = _ref3.hit,
      attribute = _ref3.attribute,
      _ref3$tagName = _ref3.tagName,
      tagName = _ref3$tagName === void 0 ? 'mark' : _ref3$tagName,
      _ref3$createElement = _ref3.createElement,
      createElement = _ref3$createElement === void 0 ? preactCreateElement : _ref3$createElement;
  return parseAlgoliaHitSnippet({
    hit: hit,
    attribute: attribute
  }).map(function (x, index) {
    return x.isHighlighted ? createElement(tagName, {
      key: index
    }, x.value) : x.value;
  });
}
/**
 * Highlights and escapes the non-matching parts of an Algolia hit snippet.
 *
 * This is a common pattern for Query Suggestions.
 */

export function reverseSnippetHit(_ref4) {
  var hit = _ref4.hit,
      attribute = _ref4.attribute,
      _ref4$tagName = _ref4.tagName,
      tagName = _ref4$tagName === void 0 ? 'mark' : _ref4$tagName,
      _ref4$createElement = _ref4.createElement,
      createElement = _ref4$createElement === void 0 ? preactCreateElement : _ref4$createElement;
  return parseAlgoliaHitReverseSnippet({
    hit: hit,
    attribute: attribute
  }).map(function (x, index) {
    return x.isHighlighted ? createElement(tagName, {
      key: index
    }, x.value) : x.value;
  });
}